class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.hoverController = new AbortController();
    const options = { signal: this.hoverController.signal };
    this.header = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
    this.hoverMedia.addEventListener('change', () => {
      if (!this.hoverMedia.matches) this.close();
    }, options);
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.mainDetailsToggle.open && !this.contains(document.activeElement)) this.close();
    }, options);
    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('pointerenter', (event) => {
        if (!this.hoverMedia.matches || event.pointerType !== 'mouse') return;
        clearTimeout(details.smartCloseTimer);
        // Close sibling branches while leaving this branch's ancestors open.
        this.header.querySelectorAll('header-menu details[open]').forEach((other) => {
          if (other !== details && !other.contains(details) && !details.contains(other) && !other.contains(document.activeElement)) {
            other.open = false;
          }
        });
        details.open = true;
      }, options);
      details.addEventListener('pointerleave', (event) => {
        if (!this.hoverMedia.matches || event.pointerType !== 'mouse') return;
        details.smartCloseTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 180);
      }, options);
      details.addEventListener('toggle', () => {
        details.querySelector(':scope > summary').setAttribute('aria-expanded', String(details.open));
      }, options);
    });
  }

  disconnectedCallback() {
    this.hoverController?.abort();
    this.querySelectorAll('details').forEach((details) => clearTimeout(details.smartCloseTimer));
  }

  onToggle() {
    if (!this.header) return;
    if (!this.mainDetailsToggle.open) {
      this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    }
    this.header.preventHide = Boolean(this.header.querySelector('header-menu > details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
